export const blockIconsImageAutoFixHigh = (
	<span className='material-symbols-outlined'>auto_fix_high</span>
);
